<div class="detail-box">
  <div class="column-list" style="padding:8px;">
    <label class="list-input-title">備考</label>
    <div class="list-input-content">
      <app-text-area id="txi_Remarks" [subid]="'txi_Remarks'"
        [forcedEnabledMode]="'true'" [displayCountField]="false" [(ngModel)]="remarks"
        [restrict]="'[ -￮]'" [maxChars]="128" [disabled]="disabledFlag" [fullOnly]="true"
        (input)="eventImageInfoDetailCHANGE.emit($event)">
      </app-text-area>
    </div>

    <label class="list-input-title">使用開始受注コード</label>
    <div class="list-input-content">
      <app-order-code-text-input id="txi_StartOrderCode" #txi_StartOrderCode [subid]="'txi_StartOrderCode'"
        [forcedEnabledMode]="'true'" [tabindex]="0" [disabled]="disabledFlag"
        [(ngModel)]="startOrderCode" (ngModelChange)="changeStartOrderCode.emit($event)">
      </app-order-code-text-input>
    </div>

    <label class="list-input-title">使用終了受注コード</label>
    <div class="list-input-content">
      <app-order-code-text-input id="txi_EndOrderCode1" #txi_EndOrderCode1 [subid]="'txi_EndOrderCode1'"
        [forcedEnabledMode]="'true'" [tabindex]="0" [disabled]="disabledEndOrderCode1"
        [editable]="!readonlyEndOrderCode1" [(ngModel)]="endOrderCode1"
        (ngModelChange)="changeEndOrderCode1.emit($event)">
      </app-order-code-text-input>
    </div>

    <div></div>
    <div class="list-input-content">
      <select id="cmb_EndOrderCode2" #cmb_EndOrderCode2 [(ngModel)]="endOrderCode2"
        forcedEnabledMode="true" [disabled]="disabledFlag"
        (change)="eventImageInfoDetailCHANGE.emit($event);changeEndOrderCode2.emit({event: $event, index: endOrderCode2})">
        <ng-template ngFor let-item [ngForOf]="endOrderCode2List">
          <option value="{{item.data}}">{{item.label}}</option>
        </ng-template>
      </select>
    </div>

    <label class="list-input-title">画像名</label>
    <div class="list-input-content">
      <input type="text" id="lbl_ImageName" value="{{imageName}}" readonly>
    </div>

    <label class="list-input-title">画像ファイル名</label>
    <div class="list-input-content">
      <input type="text" id="lbl_ImageFileName" value="{{imageFileName}}" readonly>
    </div>

    <label class="list-input-title">所属</label>
    <div class="list-input-content">
      <input type="text" id="lbl_ImageBelongName" value="{{imageBelongName}}" readonly>
    </div>

    <label class="list-input-title">画像種類</label>
    <div class="list-input-content">
      <input type="text" id="lbl_ImageKindName" value="{{imageKindName}}" readonly>
    </div>

    <label class="list-input-title">画像種別</label>
    <div class="list-input-content">
      <input type="text" id="lbl_ImageTypeName" value="{{imageTypeName}}" readonly>
    </div>

    <label class="list-input-title">調理指示</label>
    <div class="list-input-content">
      <app-code-combo-box id="cmb_ProcessInstruct" [subid]="'cmb_ProcessInstruct'" #cmb_ProcessInstruct
        [codeDiv]="'ct368'" [forcedEnabledMode]="'true'"
        [disabled]="disabledProcessInstruct" [labelField]="'codeValueName'"
        (change)="eventImageInfoDetailCHANGE.emit($event)">
      </app-code-combo-box>
    </div>

    <label class="list-input-title">調理例掲載区分</label>
    <div class="list-input-content">
      <label><input type="checkbox" id="ckb_CookingExPublish" forcedEnabledMode="true"
          [(ngModel)]="cookingExPublish" [disabled]="disabledFlag" (input)="eventImageInfoDetailCHANGE.emit($event)">掲載あり</label>
    </div>

    <label class="list-input-title">優先度</label>
    <div class="list-input-content">
      <app-text-input id="txi_Priority" [subid]="'txi_Priority'"
        [forcedEnabledMode]="'true'" [displayCountField]="false" [(ngModel)]="priority"
        [restrict]="'[0-9]'" [maxChars]="2" [disabled]="disabledFlag"
        (input)="eventImageInfoDetailCHANGE.emit($event)" style="width:2rem;">
      </app-text-input>
    </div>

    <label class="list-input-title">Ｐコード</label>
    <div class="list-input-content">
      <input type="text" id="lbl_Pcode" class="pcode" value="{{pcode}}" readonly>
    </div>

    <label class="list-input-title">商品案内用商品名</label>
    <div class="list-input-content">
      <input type="text" id="lbl_GuideGoodsName" value="{{guideGoodsName}}" readonly>
    </div>

    <label class="list-input-title">商品案内用規格名</label>
    <div class="list-input-content">
      <input type="text" id="lbl_GuideGoodsName" class="guide-standard-name" value="{{guideStandardName}}" readonly>
    </div>

    <label class="list-input-title">料理分類</label>
    <div class="list-input-content">
      <app-code-combo-box id="cmb_CookingDiv" #cmb_CookingDiv [subid]="'cmb_CookingDiv'" [codeDiv]="'ct369'"
        [forcedEnabledMode]="'true'" [disabled]="disabledFlag"
        [labelField]="'codeValueName'" (change)="eventImageInfoDetailCHANGE.emit($event)">
      </app-code-combo-box>
    </div>

    <label class="list-input-title">料理名</label>
    <div class="list-input-content">
      <app-text-input id="txi_CookingName" [subid]="'txi_CookingName'"
        [forcedEnabledMode]="'true'" [displayCountField]="false" [(ngModel)]="cookingName"
        [restrict]="'[ -￮]'" [maxChars]="20" [disabled]="disabledFlag" [fullOnly]="true"
        (input)="eventImageInfoDetailCHANGE.emit($event)" style="width:22rem;">
      </app-text-input>
    </div>

    <label class="list-input-title">材料名</label>
    <div class="list-input-content">
      <app-text-input id="txi_MaterialName" [subid]="'txi_MaterialName'"
        [forcedEnabledMode]="'true'" [displayCountField]="false" [(ngModel)]="materialName"
        [restrict]="'[ -￮]'" [maxChars]="20" [disabled]="disabledFlag" [fullOnly]="true"
        (input)="eventImageInfoDetailCHANGE.emit($event)" style="width:22rem;">
      </app-text-input>
    </div>

    <label class="list-input-title">キーワード</label>
    <div class="list-input-content">
      <app-text-area id="txi_KeyWord" [subid]="'txi_KeyWord'"
        [forcedEnabledMode]="'true'" [displayCountField]="false" [(ngModel)]="keyWord"
        [restrict]="'[ -￮]'" [maxChars]="128" [disabled]="disabledFlag" [fullOnly]="true"
        (input)="eventImageInfoDetailCHANGE.emit($event)">
      </app-text-area>
    </div>

    <label class="list-input-title">催事・季節</label>
    <div class="list-input-content">
      <app-code-combo-box id="cmb_EventId" #cmb_EventId [subid]="'cmb_EventId'" [codeDiv]="'ct370'"
        [forcedEnabledMode]="'true'" [disabled]="disabledFlag"
        [labelField]="'codeValueName'" (change)="eventImageInfoDetailCHANGE.emit($event)">
      </app-code-combo-box>
    </div>

    <label class="list-input-title">撮影内容区分</label>
    <div class="list-input-content">
      <app-code-combo-box id="cmb_PhotoContentsDiv" #cmb_PhotoContentsDiv [subid]="'cmb_PhotoContentsDiv'"
        [codeDiv]="'ct372'" [forcedEnabledMode]="'true'"
        [disabled]="disabledFlag" [labelField]="'codeValueName'" (change)="eventImageInfoDetailCHANGE.emit($event)">
      </app-code-combo-box>
    </div>

    <label class="list-input-title">撮影指示内容</label>
    <div class="list-input-content">
      <app-text-area id="txi_PhotoInstructContents" [subid]="'txi_PhotoInstructContents'"
        [forcedEnabledMode]="'true'" [displayCountField]="false"
        [(ngModel)]="photoInstructContents" [restrict]="'[ -￮]'" [maxChars]="128" [disabled]="disabledFlag"
        [fullOnly]="true" (input)="eventImageInfoDetailCHANGE.emit($event)">
      </app-text-area>
    </div>

    <label class="list-input-title">撮影予定日</label>
    <div class="list-input-content">
      <wj-input-date id="dfd_PhotoSchedule" #dfd_PhotoSchedule
        forcedEnabledMode="true" [(text)]="photoSchedule" [isRequired]="false"
        [value]="null" (input)="eventImageInfoDetailCHANGE.emit($event)">
      </wj-input-date>
    </div>

    <label class="list-input-title">撮影場所</label>
    <div class="list-input-content">
      <app-studio-master-combo-box id="cmb_PhotoStudioId" #cmb_PhotoStudioId [subid]="'cmb_PhotoStudioId'"
        [forcedEnabledMode]="'true'" [disabled]="disabledFlag"
        (change)="eventImageInfoDetailCHANGE.emit($event)">
      </app-studio-master-combo-box>
    </div>

    <label class="list-input-title">作成指示日</label>
    <div class="list-input-content">
      <input type="text" id="lbl_ImageInstructDate" class="date" value="{{imageInstructDate}}" readonly>
    </div>

    <label class="list-input-title">画像ファイル登録日</label>
    <div class="list-input-content">
      <input type="text" id="lbl_FileRegistDate" class="date" value="{{fileRegistDate}}" readonly>
    </div>

    <label class="list-input-title">画像キャプション</label>
    <div class="list-input-content">
      <app-text-area id="txi_Caption" [subid]="'txi_Caption'"
        [forcedEnabledMode]="'true'" [displayCountField]="false" [(ngModel)]="caption"
        [restrict]="'[ -￮]'" [maxChars]="50" [disabled]="disabledFlag" [fullOnly]="true"
        (input)="eventImageInfoDetailCHANGE.emit($event)">
      </app-text-area>
    </div>
  </div>
</div>
